import React from 'react';
import { Input, Icon } from 'antd';

class Search extends React.Component {
    searchQuery = this.props.defaultValue;

    static defaultProps = {
        focusOnEmpty: true
    };

    checkFocus(text) {
        if (
            this.el &&
            ((text != null && text.length) || this.props.focusOnEmpty)
        ) {
            setTimeout(() => {
                if (this.el) {
                    this.el.focus();
                }
            }, 400);
        }
    }

    searcher = text => {
        const { props } = this;

        this.searchQuery = text;

        if (props.onSearch) {
            props.onSearch(text);
        }
    };

    onPressEnter = e => {
        const { props } = this;
        const text = e.target.value;

        this.searcher(text);

        if (props.onPressEnter) {
            props.onPressEnter(text);
        }
    };

    componentDidMount() {
        // claude: on a phone the focus would open the on-screen keyboard over the page as soon as it opens;
        // the width is MOBILE_QUERY of common/lib/mobile
        if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) return;

        this.checkFocus(this.props.defaultValue);
    }

    render() {
        const props = { ...this.props };

        const style = { width: 250, ...props.style };
        delete props.style;
        delete props.focusOnEmpty;

        return (
            <Input.Search
                allowClear
                ref={el => (this.el = el)}
                placeholder={_('search')}
                addonAfter={
                    this.searchQuery != null && this.searchQuery.length ? (
                        <a onClick={e => this.searcher('')}>
                            <Icon
                                style={{ color: '#f00', fontWeight: 700 }}
                                type="close"
                            />
                        </a>
                    ) : null
                }
                style={style}
                {...props}
                onPressEnter={this.onPressEnter}
                onSearch={this.searcher}
            >
                {props.children}
            </Input.Search>
        );
    }
}

export default Search;
